import React, { useMemo } from 'react';
import { Flex, Popover, Progress, ProgressProps, theme } from 'antd';
import { isCustom } from '@prerender/billing-shared';

import { TOOLTIP_ROOT_ID } from '../../components/Tooltip';
import { BillingOverviewPlan } from '../../features/billing/overview/BillingOverviewPlan';
import { usePrerenderUser, useCurrentRenderCount, useRenderUsagePercentage } from '../../hooks/usePrerenderUser';

export const RenderCounter = () => {
  const { token } = theme.useToken();
  const user = usePrerenderUser();
  const isUserOnCustomPlan = isCustom(user.chargebeePlanId);
  const currentCount = useCurrentRenderCount();
  const percent = useRenderUsagePercentage();

  const adjustedPercent = Math.min(percent, 100);
  const isAtLimit = percent >= 100;

  const strokeColor: ProgressProps['strokeColor'] = useMemo(() => {
    if (percent >= 90) return token.colorError;
    if (percent >= 75) return token.colorWarning;
    return token.colorPrimary;
  }, [percent, token]);

  const labelColor = isAtLimit ? token.colorTextLightSolid : strokeColor;

  return (
    <Popover
      styles={{ body: { width: 380 } }}
      placement="bottom"
      trigger={['click']}
      content={<BillingOverviewPlan user={user} isUserOnCustomPlan={isUserOnCustomPlan} showBillingPageLink />}
    >
      <Flex
        vertical
        style={{ cursor: 'pointer', padding: token.paddingXXS }}
        data-tooltip-id={TOOLTIP_ROOT_ID}
        data-tooltip-content={`Renders ${currentCount.toLocaleString()}/${user.plan.limit.toLocaleString()}`}
        data-tooltip-place="bottom"
      >
        <Progress
          style={{ borderRadius: '50%', backgroundColor: isAtLimit ? token.colorError : undefined }}
          percent={adjustedPercent}
          size={token.controlHeightLG}
          type="circle"
          strokeColor={strokeColor}
          strokeWidth={10}
          format={(value) => (
            <span style={{ color: labelColor }}>{value ? `${Math.floor(adjustedPercent)}%` : '0%'}</span>
          )}
        />
      </Flex>
    </Popover>
  );
};
